import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadingOverlay } from "react-overlay-loader";
import { DefaultTaxYearConstants } from "../../../helper/Constants";
import { ApplicationState } from "../../../store";
import { actionTypes } from "../../../types/userSettingsTypes";
import Dropdown from "react-dropdown";
import { getDefaultTaxYearOptions } from "../../../helper/HelperFunctions";
import { Option } from "react-dropdown";

interface IDefaultTaxYearState {
    defaultTaxYear: Option;
}

const DefaultTaxYear = () => {
    const dispatch = useDispatch();
    const taxYearsOptions = React.useMemo(() => {
        return getDefaultTaxYearOptions();
    }, []); 

    const currentDate = new Date();
    const mayFirst = new Date(currentDate.getFullYear(), 4, 1); 
    const selectedDefaultTaxYear = currentDate >= mayFirst ? currentDate.getFullYear() : currentDate.getFullYear() - 1;
    const initialOption = { value: selectedDefaultTaxYear.toString(), label: selectedDefaultTaxYear.toString() };
    const { userSettings} = useSelector((appState: ApplicationState) => appState.userSettingsState);
    const [defaultTaxYearState, setDefaultTaxYearState] = useState<IDefaultTaxYearState>({ defaultTaxYear: initialOption, });
    const getSelectedOption = (value: number): Option => {
          const val = value.toString();
          const foundOption = taxYearsOptions.find(ty => ty?.value === val);
          return { value: foundOption?.value || "", label: foundOption?.label || "" } ;
        };
    
    useEffect(() => {
        if (userSettings?.taxYearSettings?.defaultTaxYear)
        {
           const dtYear = getSelectedOption(userSettings.taxYearSettings.defaultTaxYear);
           setDefaultTaxYearState({
            ...defaultTaxYearState,
            defaultTaxYear: dtYear,
           });
        }
    }, [userSettings]);
    
    const handleDefaultTaxYearDropDownClick = (option: Option, selectedDropDown: string) => {
        setDefaultTaxYearState({
            ...defaultTaxYearState,
            [selectedDropDown]: option,
        });
        dispatch({
                    type: actionTypes.UPDATE_USER_SETTINGS,
                    payload: { ...userSettings, taxYearSettings: {defaultTaxYear: option.value} },
                });
    };

    return (
        <LoadingOverlay>
            <div className="message-options-parent-container">
                <header>
                    <h3>{DefaultTaxYearConstants.DEFAULT_Tax_YEAR_TITLE}</h3>
                    <span>{DefaultTaxYearConstants.DEFAULT_Tax_YEAR__HELPER_TEXT_USER_SETTINGS}</span>
                </header>
            </div>
                <div className="settings-accordian-container">
                    <div className="settings-label-dropdown-wrapper">
                    <h5>{DefaultTaxYearConstants.DEFAULT_Tax_YEAR_TITLE}</h5>
                            <Dropdown
                                className="setting-dropdown"
                                onChange={option => {
                                                        handleDefaultTaxYearDropDownClick(option, "defaultTaxYear");
                                                    }}
                                placeholder="Select Default Tax Year"
                                options={taxYearsOptions}
                                value={defaultTaxYearState.defaultTaxYear}
                            />
                    </div>
                </div>
        </LoadingOverlay>
    );
};

export default DefaultTaxYear;
